const SIGNED_UP = 'SIGNED_UP'
const NOT_SIGNED_UP = 'NOT_SIGNED_UP'
const SIGN_UP_IN_PROGRESS = 'SIGN_UP_IN_PROGRESS'
const SIGN_UP_ERROR = 'SIGN_UP_ERROR'

export { NOT_SIGNED_UP, SIGN_UP_ERROR, SIGN_UP_IN_PROGRESS, SIGNED_UP }
